import React, { useState } from 'react';
import heroAboutUs from '../assets/images/30669.webp';
import { ReactComponent as Magnifier } from "../assets/icons/Minimalistic Magnifer.svg";
import { useNavigate } from 'react-router-dom';

interface HeroProps {
  onAdventureClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onAdventureClick }) => {
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (loading) return;

    const trimmedSearchText = searchText.trim();
    if (!trimmedSearchText) return;

    setLoading(true);
    try {
      navigate(`/search-results?q=${encodeURIComponent(trimmedSearchText)}`);
    } catch (error) {
      console.error('Navigation failed:', error);
    } finally {
      // استفاده از setTimeout برای اطمینان از اتمام navigation
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleMagnifierClick = () => {
    handleSearch();
  };

  return (
    <div className="relative w-full h-[213px] tablet:h-[693px] desktop:h-[693px]">
      {/* Hero Image */}
      <img
        src={heroAboutUs}
        alt="لوتکا"
        className="w-full h-full object-cover"
        loading="eager"
        fetchPriority="high"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/10 flex flex-col justify-center items-center">
        {/* Title */}
        <h1 className="text-[#000000] text-center desktop:text-[32px] tablet:text-[32px] text-[18px] font-myYekanMedium px-4">
          لوتکا، اولین پلتفرم بومی سفر به گیلان
        </h1>
      </div>

      {/* Search Bar Container */}
      <div className="absolute bottom-[-20px] tablet:bottom-[250px] desktop:bottom-[240px] left-0 right-0 flex justify-center px-4">
        <div className="relative desktop:w-[700px] tablet:w-[500px] w-full max-w-[330px] tablet:max-w-[400px] desktop:max-w-[500px]">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyPress}
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
            placeholder="جستجوی جاذبه‌های دیدنی، رستوران و اقامتگاه"
            className="w-full h-10 desktop:h-12 font-myYekanRegular text-[#222222] text-[12px] desktop:text-[14px] pr-4 pl-10 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-gray-500 bg-white"
            disabled={loading}
          />

          <button
            onClick={handleMagnifierClick}
            disabled={loading}
            className={`absolute left-2 top-1/2 -translate-y-1/2 flex items-center justify-center rounded-full p-1.5 transition-colors ${
              isInputFocused ? 'bg-gray-200' : 'hover:bg-gray-100'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
            aria-label="جستجو"
          >
            <Magnifier className="w-5 h-5 text-gray-500 hover:text-gray-700 transition-colors" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;